export default {
  login: "Sign in",
  logout: "Sign out",
  loggingIn: "Signing in…",
  selectIdp: "Choose a sign-in method",
  forbidden: {
    title: "You do not have permission for this action",
    description: "Contact an administrator if you need access.",
  },
  userMenu: {
    account: "Account",
    groups: "Groups",
  },
  theme: {
    label: "Theme",
    light: "Light",
    dark: "Dark",
    system: "Match system",
  },
  language: {
    label: "Language",
    ja: "日本語",
    en: "English",
  },
} as const;
